import { render, staticRenderFns } from "./PatientsList.vue?vue&type=template&id=3f6d0885&"
import script from "./PatientsList.vue?vue&type=script&lang=js&"
export * from "./PatientsList.vue?vue&type=script&lang=js&"
import style0 from "./PatientsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports